// utils/translationHelper.js

/**
 * Получает текст на нужном языке с фоллбэком из массива переводов
 * @param {Object} textObject - Объект с переводами { translations: [{languageCode: "kz", textValue: "..."}] }
 * @param {String} currentLanguage - Текущий язык (kz, ru, en)
 * @returns {String} - Текст на нужном языке или фоллбэк
 */
export const getTranslatedText = (textObject, currentLanguage) => {
  if (!textObject || !textObject.translations || !Array.isArray(textObject.translations)) {
    return '';
  }
  
  const { translations } = textObject;
  
  // Приоритет: текущий язык → английский → русский → любой доступный
  const fallbackOrder = [currentLanguage, 'en', 'ru', 'kz'];
  
  for (const lang of fallbackOrder) {
    const translation = translations.find(t => t.languageCode === lang);
    if (translation && translation.textValue && translation.textValue.trim()) {
      return translation.textValue;
    }
  }
  
  // Если ничего не найдено, возвращаем первый доступный перевод
  const firstTranslation = translations.find(t => t.textValue && t.textValue.trim());
  return firstTranslation ? firstTranslation.textValue : '';
};

/**
 * Применяет переводы ко всей новости
 * @param {Object} newsItem - Объект новости с переводами
 * @param {String} currentLanguage - Текущий язык
 * @returns {Object} - Новость с выбранными переводами
 */
export const translateNewsItem = (newsItem, currentLanguage) => {
  if (!newsItem) return null;
  
  return {
    ...newsItem,
    title: getTranslatedText(newsItem.title, currentLanguage),
    description: getTranslatedText(newsItem.description, currentLanguage)
  };
};

/**
 * Применяет переводы к массиву новостей
 * @param {Array} newsArray - Массив новостей
 * @param {String} currentLanguage - Текущий язык
 * @returns {Array} - Новости с выбранными переводами
 */
export const translateNewsArray = (newsArray, currentLanguage) => {
  if (!Array.isArray(newsArray)) return [];
  
  return newsArray.map(newsItem => translateNewsItem(newsItem, currentLanguage));
};